export default __webpack_public_path__ + "static/media/brandsActive.7001be20.svg";